import { format, parseISO, Locale } from "date-fns";
import { fr, enUS } from "date-fns/locale";
import i18n from "@libs/i18n";
import { LocalDateTime } from "@gen/travel/v1/common_pb";
import { localDateTimeToDate } from "./date";

const locales: Record<string, Locale> = {
  fr,
  en: enUS,
};

export function formatDate(dateString: string): string {
  if (!dateString) return "";

  const parsedDate = parseISO(dateString);
  const locale = locales[i18n.language] || locales["fr"];

  return format(parsedDate, "dd/MM/yyyy HH:mm", { locale });
}

export function formatMinutes(duration: number) {
  if (!duration) return;

  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;

  return hours > 0
    ? `${hours}h${minutes.toString().padStart(2, "0")}`
    : `${minutes} min`;
}

export const formatLocalDateTime = (ldt?: LocalDateTime) => {
  if (!ldt) return "";
  const date = localDateTimeToDate(ldt);
  return format(date, "eeee dd MMMM yyyy", { locale: locales[i18n.language] });
};
